import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalComponent } from "../../../global-component";
import { GenericGetData } from "../../../core/models/get-data.model";
import { SaveSede } from "../models/request/save-sede.model";
import { GetSedeResponse } from "../models/sede.model";
import { SelectOptionResponse } from '../../../shared/models/generic-entities.model';

@Injectable({
  providedIn: 'root'
})
export class SedeService {

  private urlService = 'configuraciones/sede/';
  constructor(private http: HttpClient) { }

  getAll(page: number, pageSize: number, filter: string) {
    let urlFilter = page === 0 || pageSize === 0 ? "" : `?pageNumber=${page}&pageSize=${pageSize}&filter=${filter}`;
    return this.http.get<GenericGetData<GetSedeResponse[]>>(`${GlobalComponent.API_URL}${this.urlService}${"getall"}${urlFilter}`, { reportProgress: true, observe: "events" });
  }

  getAllSelectOption(proyectos: string[]) {
    let params = new HttpParams();
    proyectos.forEach(element => {
      params = params.append('ids', element);
    });
    return this.http.get<SelectOptionResponse[]>(`${GlobalComponent.API_URL}${this.urlService}select`, { params: params, reportProgress: true, observe: "events" });
  }
  
  save(data: SaveSede) {
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"save"}`, data, { reportProgress: true, observe: "events" });
  }

  edit(data: SaveSede) {
    return this.http.post(`${GlobalComponent.API_URL}${this.urlService}${"edit"}`, data, { reportProgress: true, observe: "events" });
  }
}
